export var StoreItemVariantDesktopEnum;
(function (StoreItemVariantDesktopEnum) {
    StoreItemVariantDesktopEnum["THUMBNAIL_TOP"] = "THUMBNAIL_TOP";
    StoreItemVariantDesktopEnum["THUMBNAIL_RIGHT"] = "THUMBNAIL_RIGHT";
    StoreItemVariantDesktopEnum["THUMBNAIL_LEFT"] = "THUMBNAIL_LEFT";
})(StoreItemVariantDesktopEnum || (StoreItemVariantDesktopEnum = {}));
export var StoreItemVariantMobileEnum;
(function (StoreItemVariantMobileEnum) {
    StoreItemVariantMobileEnum["LEGACY"] = "LEGACY";
    StoreItemVariantMobileEnum["THUMBNAIL_LEFT"] = "THUMBNAIL_LEFT";
    StoreItemVariantMobileEnum["THUMBNAIL_RIGHT"] = "THUMBNAIL_RIGHT";
    StoreItemVariantMobileEnum["THUMBNAIL_TOP"] = "THUMBNAIL_TOP";
    StoreItemVariantMobileEnum["STRIP"] = "STRIP";
    StoreItemVariantMobileEnum["TOP_SELLING_ITEM_THUMBNAIL_TOP"] = "TOP_SELLING_ITEM_THUMBNAIL_TOP";
})(StoreItemVariantMobileEnum || (StoreItemVariantMobileEnum = {}));
export var RecommendedWrapVariantEnum;
(function (RecommendedWrapVariantEnum) {
    RecommendedWrapVariantEnum["TWO_ITEMS_ROW"] = "two_items_row";
    RecommendedWrapVariantEnum["SINGLE_ITEM_ROW"] = "single_item_row";
})(RecommendedWrapVariantEnum || (RecommendedWrapVariantEnum = {}));
export var RecommendedItemSizeEnum;
(function (RecommendedItemSizeEnum) {
    RecommendedItemSizeEnum["SMALL"] = "small";
    RecommendedItemSizeEnum["MEDIUM"] = "medium";
    RecommendedItemSizeEnum["LARGE"] = "large";
})(RecommendedItemSizeEnum || (RecommendedItemSizeEnum = {}));
//# sourceMappingURL=store-item-variant.enum.js.map